import { useQuery } from '@tanstack/react-query'
import { actionsApi } from '../api/actions'
import { useActionsFilters } from '../lib/useActionsFilters'
import { OpenActionsGroups } from '../components/OpenActionsGroups'
import { ActionsFilters } from '../components/ActionsFilters'
import { IntelligenceInbox } from '../components/IntelligenceInbox'
import { Spinner } from '../components/Spinner'

export default function OpenActionsByWeek() {
  const { filters, set, isDefault, reset } = useActionsFilters()
  const { status, week, reviewWeek, clientId } = filters

  const { data, isLoading } = useQuery({
    queryKey: ['open-actions', status, week, reviewWeek, clientId],
    queryFn: () =>
      actionsApi.open({
        status,
        week: week || undefined,
        reviewWeek: reviewWeek || undefined,
        clientId: clientId || undefined,
      }),
  })
  const actions = data?.actions ?? []

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-slate-900">Ações por semana</h1>
        {!isLoading && (
          <span className="rounded-full bg-slate-100 px-3 py-1 text-sm font-medium text-slate-600">
            {actions.length} {actions.length === 1 ? 'ação' : 'ações'}
          </span>
        )}
      </div>

      <IntelligenceInbox clientId={clientId || undefined} compact />

      <ActionsFilters
        status={status}
        week={week}
        reviewWeek={reviewWeek}
        clientId={clientId}
        onStatus={(s) => set('status', s)}
        onWeek={(w) => set('week', w)}
        onReviewWeek={(w) => set('reviewWeek', w)}
        onClientId={(id) => set('clientId', id)}
        onReset={reset}
        isDefault={isDefault}
      />

      {isLoading ? <Spinner /> : <OpenActionsGroups actions={actions} groupBy="week" />}
    </div>
  )
}
